import ApiService, { ConfigService } from "@/common/api.service"
import {
  FETCH_LANGS,
  FETCH_CONFIG_ITEMS,
  CONFIG_ITEMS_CREATE,
  CONFIG_ITEMS_EDIT
} from "./actions.type"
import {
  SET_CONFIG_ITEM,
  SET_CONFIG_ITEMS,
  SET_LANGS
} from "./mutations.type";
import { displayNotification } from "@/common/notification";

const initialState = {
  configItems: [
    { 
      key: '',
      value: '',
      label: '',
      type: ''
    }
  ],
  langs: null
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_CONFIG_ITEMS](context) {
    const { data } = await ConfigService.get();
    context.commit(SET_CONFIG_ITEMS, data.config.items);
    return data.config.items;
  },

  async [CONFIG_ITEMS_CREATE]({ state, commit }, items) {
    return await ConfigService.create(items)
  },

  async [CONFIG_ITEMS_EDIT]({ state, commit }, items) {
    commit(SET_CONFIG_ITEMS, items);
    
    try {
      const res = await ConfigService.update({ items: items })
      displayNotification("Sucessfully updated config", "success");
      return res
    } catch {
      displayNotification("Updating config failed", "warning");
    }
  },

  async [FETCH_LANGS](context) {
    return ApiService.get("langs")
      .then(({ data }) => {
        context.commit(SET_LANGS, data.langs);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {

  [SET_CONFIG_ITEM](state, { key, value }) {
    let item = _.find(state.configItems, item => {
      return item.key === key
    })
    item.value = value
  },

  [SET_CONFIG_ITEMS](state, items) {
    state.configItems = items;
  },

  [SET_LANGS](state, langs) {
    state.langs = langs;
  }
};

const getters = {
  configItems(state) {
    return state.configItems;
  },
  langs(state) {
    return state.langs;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
